import { render, staticRenderFns } from "./Fishing.vue?vue&type=template&id=2358d281&scoped=true&"
import script from "./Fishing.vue?vue&type=script&lang=js&"
export * from "./Fishing.vue?vue&type=script&lang=js&"
import style0 from "./Fishing.vue?vue&type=style&index=0&id=2358d281&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2358d281",
  null
  
)

export default component.exports